export default __webpack_public_path__ + "static/media/Commander's Chestguard of the Watchtowers.9073af61.jpg";